import './NotFound.css';

const NotFound = () => {
  return (
    <div className='not-found'>
      <h2>404 Not Found</h2>
      <h3>This page does not exist in this universe.</h3>
    </div>
  )
};

export default NotFound;